import React from "react";
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Comment from "./comment";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import {withTranslation} from "react-i18next";

const ZajavlConfirmDialog = (
    {
        isOpenConfirmDialog,
        uuidConfirm,
        zajavlActionConfirm,
        handleCloseConfirmDialog,
        handleSaveAndSend,
        handleCancel,
        handleRemove,
        handleRemoveContest,
        t,
        i18n
    }) => {
    let continueBtn;
    switch (zajavlActionConfirm) {
        case 'send':
            continueBtn = handleSaveAndSend;
            break;
        case 'cancel':
            continueBtn = handleCancel;
            break;
        case 'remove':
            continueBtn = handleRemove;
            break;
        case 'remove-contest':
            continueBtn = handleRemoveContest;
            break;
        default:
            continueBtn = null;
    }
    const isLangEn = i18n.language === 'en'
    return(
        <Dialog
            open={isOpenConfirmDialog}
            onClose={handleCloseConfirmDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{t('action_confirm')}</DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    {zajavlActionConfirm === 'send'
                        ? <Grid item xs={12}>
                            {isLangEn
                                ? <>
                                    <Typography variant="subtitle1">By submitting the application, you confirm:</Typography>
                                    <ul>
                                        <li>
                                            <Typography variant="body1">
                                                that you have reviewed the copy of the license for educational activities, the copy of the state accreditation certificate, and their appendices;
                                            </Typography>
                                        </li>
                                        <li>
                                            <Typography variant="body1">
                                                that you are aware of the deadlines for applicants to submit the original document of the established format for state-funded spots, and the deadlines for submitting consent to enrollment for spots under paid education service contracts;
                                            </Typography>
                                        </li>
                                        <li>
                                            <Typography variant="body1">
                                                that you have reviewed the rules for filing appeals regarding the results of entrance examinations conducted by the institution independently;
                                            </Typography>
                                        </li>
                                        <li>
                                            <Typography variant="body1">
                                                that you are aware of the responsibility for the accuracy of the information provided in the application and for the authenticity of the documents submitted for admission.
                                            </Typography>
                                        </li>
                                    </ul>
                                </>
                                : <>
                                    <Typography variant="subtitle1">Подавая заявление, вы подтверждаете:</Typography>
                                    <ul>
                                        <li>
                                            <Typography variant="body1">
                                                ознакомление с копией лицензии на осуществление образовательной деятельности, копией
                                                свидетельства о государственной аккредитации и приложений к ним;
                                            </Typography>
                                        </li>
                                        <li>
                                            <Typography variant="body1">
                                                ознакомление с датами завершения представления поступающими оригинала документа
                                                установленного образца на места в рамках контрольных цифр, с датами завершения
                                                представления поступающими сведений о согласии на зачисление на места по договорам
                                                об оказании платных образовательных услуг;
                                            </Typography>
                                        </li>
                                        <li>
                                            <Typography variant="body1">
                                                ознакомление с правилами подачи апелляции по результатам вступительных испытаний,
                                                проводимых организацией самостоятельно;
                                            </Typography>
                                        </li>
                                        <li>
                                            <Typography variant="body1">
                                                ознакомление с информацией об ответственности за достоверность сведений, указываемых
                                                в заявлении о приёме, и за подлинность документов, подаваемых для поступления.
                                            </Typography>
                                        </li>
                                    </ul>
                                </>
                            }
                        </Grid>
                        : null}
                    {zajavlActionConfirm === 'cancel'
                        ? <Grid item xs={12}>
                            <Typography variant="subtitle1">
                                {isLangEn
                                    ? 'Are you sure you want to withdraw your application?'
                                    : 'Вы уверены, что хотите отозвать заявление?'
                                }
                            </Typography>
                        </Grid>
                        : null}
                    {zajavlActionConfirm === 'remove'
                        ? <Grid item xs={12}>
                            <Typography variant="subtitle1">
                                {isLangEn
                                    ? 'Are you sure you want to delete the application?'
                                    : 'Вы уверены, что хотите удалить заявление?'
                                }
                            </Typography>
                        </Grid>
                        : null}
                    {zajavlActionConfirm === 'remove-contest'
                        ? <Grid item xs={12}>
                            <Typography variant="subtitle1">
                                {isLangEn
                                    ? 'Are you sure you want to remove the contest from the application?'
                                    : 'Вы уверены, что хотите удалить конкурс из заявления?'
                                }
                            </Typography>
                        </Grid>
                        : null}
                    {['send', 'cancel'].indexOf(zajavlActionConfirm) !== -1
                        ? <Grid item xs={12}>
                            <Comment zajavlUuidConfirm={uuidConfirm} />
                        </Grid>
                        : null}
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseConfirmDialog} color="primary">
                    {t('cancel')}
                </Button>
                <Button onClick={continueBtn} color="primary" autoFocus>
                    {t('continue')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
export default withTranslation()(ZajavlConfirmDialog);
